import { createActionGroup, props } from '@ngrx/store';

import { RockModel } from './models/rock.model';

export const RockActions = createActionGroup({
  source: 'Rocks',
  events: {
    'Universal Create Success': props<{
      rock: RockModel;
      dispatchSource: string;
      toastMessage: string;
      skipAutoClose?: boolean;
    }>(),
  },
});
